import Vue from "vue";
import Router from "vue-router";
import routes from "./routes.js";
const vue = Vue.prototype;
Vue.use(Router);
const router = new Router({
  // mode: "history",
  routes,
});
//全局路由守卫
// router.beforeEach((to, from, next) => {
//   if (localStorage.getItem("token")) {
//     console.log("离开" + from.meta.title);
//     next();
//   } else {
//     vue.$message({
//       message: "请进行登录！",
//       type: "warning",
//     });
//   }
// });
router.afterEach((to, from) => {
  document.title = to.meta.title;
  console.log("进入" + to.meta.title);
});

export default router;
